import { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { ChevronRightIcon, XIcon } from '@/components/icons';
import { useNavContext } from '@/providers/NavContextProvider';
import clsx from 'clsx';

export const FocusLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const {
    isNavCollapsed,
    setIsNavCollapsed,
    title,
    fromTitle,
    actions,
    onClose,
  } = useNavContext();
  useEffect(() => {
    setIsNavCollapsed(true);
  }, []);

  return (
    <div className="h-screen flex flex-col">
      <div className="px-8 py-4 border-b border-gray-100 shadow-sm flex items-center justify-between">
        <div
          className={clsx(
            'flex items-center gap-1',
            actions.length > 0 && 'w-2/3',
          )}
        >
          {isNavCollapsed && onClose && (
            <button
              className="tertiary"
              onClick={() => {
                onClose();
                setIsNavCollapsed!(false);
              }}
            >
              <XIcon />
            </button>
          )}
          {!fromTitle && title && (
            <div className="title-h5 truncate">{title}</div>
          )}
          {fromTitle && title && (
            <div className="title-h5 flex gap-4 items-center">
              <span
                className="cursor-pointer"
                onClick={() => {
                  onClose();
                  setIsNavCollapsed!(false);
                }}
              >
                {fromTitle}
              </span>

              <ChevronRightIcon />
              {title}
            </div>
          )}
        </div>
        {actions.length > 0 && (
          <div className="w-1/3 flex items-center justify-end gap-2">
            {actions.map((action) => (
              <div key={action.key}>{action.component}</div>
            ))}
          </div>
        )}
      </div>
      <div className="flex flex-1 overflow-y-auto">{children}</div>
    </div>
  );
};
